<template>
  <div
    class="benefit section"
    :style="sectionStyle"
  >
    <div class="container flex column items-center">
      <div
        v-if="title"
        class="row q-mb-xl"
      >
        <div
          class="text-center col-12 q-mb-lg title"
          :style="titleStyle"
          v-html="$options.filters.pureHtml(title)"
        />
        <div class="bottom-line border-radius-6 offset-4 col-4"/>
        <div
          v-if="description"
          class="text-center col-12 description"
          :style="descriptionStyle"
          v-html="$options.filters.pureHtml(description)"
        />
      </div>

      <div class="row q-col-gutter-lg">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="col-md-4 col-xs-12"
        >
          <div
            class="item q-pa-lg q-mt-none column items-center q-gutter-y-md text-center fit"
            :style="itemStyles"
          >
            <q-icon
              v-if="item.icon"
              :name="item.icon"
              size="60px"
            />
            <div
              :style="sublabelStyle"
              v-html="$options.filters.pureHtml(item.sublabel)"
            />
            <div
              :style="descriptionStyle"
              class="col flex items-center"
              v-html="$options.filters.pureHtml(item.description)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import itemBorderMixin from './mixins/itemBorderMixin';
import sublabelMixin from './mixins/sublabelMixin';
import titleMixin from './mixins/titleMixin';

export default {
  name: 'BenefitSection',
  mixins: [
    backgroundMixin,
    titleMixin,
    descriptionMixin,
    sublabelMixin,
    itemBorderMixin,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.benefit {
  .bottom-line {
    height: 6px;
    background: var(--active-color);
  }

  .q-icon {
    color: var(--active-color);
  }
}
</style>
